const initialState = {
  appSettings: [],
  fetching: false,
  fetched: false,
  errors: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "APP_SETTINGS_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: null,
      }
    case "APP_SETTINGS_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "APP_SETTINGS_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        appSettings: action.payload.data,
        errors: null,
      }
    default:
      return state
  }
}
